import closeIcon from "../../../images/_close.svg";
import approvedIcon from "../../../images/Approved.svg";
import declinedIcon from "../../../images/Declined.svg";
import deleteIcon from "../../../images/trashpink.svg"
import reviewIcon from "../../../images/Review.svg";
import { useDispatch, useSelector } from "react-redux";
import "./Template.css";
import { t } from "i18next";
import CustomTable from "../../../components/CustomTable/CustomTable";
import PrimaryButton from "../../../components/Buttons/PrimaryButton/PrimaryButton";
import CustomToolTip from "../../../components/CustomToolTip/CustomToolTip";
import Search from "../../../components/Inputs/Search/Search";
import Selector from "../../../components/Selector/Selector";
import React, {  useEffect, useMemo, useState } from "react";
import SyncModal from "./SyncModal";
import { fetchTemplatesList } from "../../../redux/features/templates_/templatesByTypeSlice";
import useMessage from "../../../hooks/useMessage";
import centralApi from "../../../services/centralApi";
import { getToken } from "redux/features/app/authTokenSlice";
import { STATUS } from "../../../redux/constant";
import { formatDate } from "helperFunctions/date";
import { BOOLEAN_OPTIONS, PAGE_OPTIONS } from "utils/constants/selectorOptions";
import { CampaignChannelTypeEnum,DateFormatEnum } from "utils/enums";
import editIcon from "../../../images/_edit.svg"
import { Link } from "react-router-dom";
import ConfirmPopUp from "components/PopUp/ConfirmPopUp/ConfirmPopUp";
import { setSelectedTemplate } from "redux/features/templates_/templateByIdSlice";
import { setCampaignData } from "redux/features/campaign/campaignDataSlice";
import { setCurrentStep } from "redux/features/campaign/campaignCreateCurrentStepSlice";
import useDebouncedValue from "hooks/useDebouncedState";
import { CopyTwoTone } from "@ant-design/icons";
import { copyText } from "helperFunctions/string";
import { Collapse, Space } from "antd";
import CustomDrawer from "components/CustomDrawer/CustomDrawer";
import { ROUTES } from "utils/constants";
import { generateNumbersInRange } from "helperFunctions/number";

type SelectedChannel = CampaignChannelTypeEnum;
 
 
const Template: React.FC = () => {
  interface TableItem {
    templateName: string;
  }

const [selectedChannel, setSelectedChannel] =useState<string>( CampaignChannelTypeEnum.ALL)
const [pageData, setPageData] = useState(PAGE_OPTIONS.PAGINATION)
const [search, setSearch] = useDebouncedValue<{
  inputValue : string
}>({ inputValue: "" }, 500);
  const { showError, showSuccess } = useMessage();
  const [modal, setModal] = useState(BOOLEAN_OPTIONS.FALSE);
  const dispatch: any = useDispatch();
  const { appId } = useSelector((state: any) => state.activeApp);
  const loginUser = useSelector((state: any) => state.loginUser.data);
  const templates = useSelector((state: any) => state.templatesList.data);
  const fetchingStatus = useSelector(
    (state: any) => state.templatesList.status
  );
  const { endDate_C } = useSelector((state: any) => state?.dateRange);
  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState<TableItem[]>([]);
  const [campaignTableData, setCampaignTableData] = useState({}); // stores cdata from appinbox  for custom drawer

  const [showDrawer, setShowDrawer] = useState(BOOLEAN_OPTIONS.FALSE); // used for custom drawer 

  const onPageChange = (value: any) => {
    setPageData(value)
  }

  
  async function deleteTemplateById(payload: {
    args: string;
    app_id: string;
    api_key: string;
  }) {
    const url: string = `/i/templates/deleteTemplate`;

    try {
      setLoading(true);
      await centralApi("GET", url, null, payload);
      showSuccess(t("templateDeleteMsg"));
      setLoading(false);
    } catch (error) {
      setLoading(false);
      showError(t("somethingWrongLabel"));
    }
  }
  const handleDeleteTemplate = (id: string) => {
    const payload = {
      args: JSON.stringify({
        isTemplateDeleted: true,
        ud: endDate_C,
        t_id: id,
      }),
      app_id: appId,
      api_key: loginUser?.api_key,
    };
    deleteTemplateById(payload);
    dispatch(
      fetchTemplatesList({
        app_id: appId,
        api_key: loginUser.api_key,
        pagination:true,
        page: pageData.current,
        pageSize:pageData.pageSize,
        query:search,
        template_type: selectedChannel,
      })
    );
    dispatch(getToken())
  };
  useEffect(() => {
    if (loginUser?.api_key) {
      dispatch(
        fetchTemplatesList({
          app_id: appId,
          api_key: loginUser.api_key,
          pagination:true,
          page: pageData.current,
          pageSize:pageData.pageSize,
          query:search,
          template_type: selectedChannel,
        })
      );
    }
  }, [loginUser?.api_key, selectedChannel,pageData,search]);
  useEffect(() => {
    if (fetchingStatus === STATUS.LOADING) {
      setLoading(true);
    } else if (fetchingStatus === STATUS.IDLE) {
      setLoading(false);
    } else if (fetchingStatus === STATUS.ERROR) {
      setLoading(false);
    }
  }, [fetchingStatus]);
  const features = useSelector((state: any) => state.featuresSetting.data);
  const channelStatus = features[0]?.channel_status;

  // Memoize the options generation for performance
  const channelOptions = useMemo(() => {
    // Pre-generate a map of campaign channel enum types for easier access
    const allChannels = Object.values(CampaignChannelTypeEnum);
    
    // If channel_status is undefined, return all enum channels
    if (!channelStatus) {
      return allChannels.map((key) => ({
        value: key,
        label: key,
      }));
    }

    // Otherwise, filter the channels where the status is true
    return allChannels
      .filter((key) => key == CampaignChannelTypeEnum.ALL || channelStatus[key] === true) // Only include enabled channels
      .map((key) => ({
        value: key,
        label: key,
      }));
  }, [channelStatus]); 
  const generateTableData = (
    templates: any,
    selectedChannel: SelectedChannel
  ) => {
    return templates.map((item: any) => {
      const isVariant = Array.isArray(item?.template);
  
      let header: string;
  
      if (isVariant) {
        const headers = item.template.map((variant: any, index: number) => {
          const headerText =
            variant?.notificationHeader ||
            variant?.message ||
            variant?.subjectData ||
            variant?.title ||
            t("naLabel");
          return `v${index + 1}: ${headerText}`;
        });
        header = headers.join("\n"); // separate each with newline
      } else {
        const template = item?.template;
        header =
          template?.notificationHeader ||
          template?.message ||
          template?.subjectData ||
          item?.header ||
          template?.title ||
          t("naLabel");
      }
  
      return {
        templateName: item.template_name,
        header, 
        campaignAttached:item.campaignAttached,
        updatedAt: item?.updatedAt
          ? formatDate(item?.updatedAt, DateFormatEnum.FULL_MONTH_TIME)
          : t("naLabel"),
        createdAt: item?.createdAt
          ? formatDate(item?.createdAt, DateFormatEnum.FULL_MONTH_TIME)
          : t("naLabel"),
        action: generateActionColumn(item._id),
      };
    });
  };

  useEffect(() => {
    if (selectedChannel && templates) {
      const tableData = generateTableData(templates, selectedChannel);

setTableData(tableData)
    }
  }, [templates, selectedChannel]);
  //generate columns of actions
  const generateActionColumn = (id: string) => (
    <div className="d-flex w-100 justify-content-center py-1">
      <ConfirmPopUp
                title={t("deleteTemplateLabel")}
                onConfirm={()=>handleDeleteTemplate(id)}
                description={t("areYouSureMsg")}
                placement="left"
                id={id}
                icon={deleteIcon}
              >
      <CustomToolTip title="Delete">
        <PrimaryButton
          className="action-btn mx-1"
        >
          <img src={closeIcon} alt={"close_icon"} className="template-action-icon" />
        </PrimaryButton>
      </CustomToolTip>
      </ConfirmPopUp>
      
      <Link to={`/dashboard/campaign/template/${id}`}>
      
      <CustomToolTip title={t("Edit")}>
                <PrimaryButton className="action-btn mx-1">
                  <img
                    src={editIcon}
                    alt={"edit_icon"}
                    className="template-action-icon"
                  ></img>
                </PrimaryButton>
              </CustomToolTip>
            </Link>   
    </div>
  );
     //columns for campaign Data table
     const campaignTableDataColumns = [
      {
        title: t("campaignNameLabel"),
        dataIndex: "name",
        key: "name",
        render: (name: string, record: { id: string; name: string }) => (
          <div className="d-flex flex-column">
            <Link
              to={`${ROUTES.DASHBOARD_CAMPAIGN}/${record.id}`}
              className="text-primary"
            >
              {name}
            </Link>
            <div className="text-disabled d-flex align-items-center justify-content-start gap-1">
              <span className="text-sm">{record.id}</span>
              <CopyTwoTone onClick={() => handleTextCopy(record.id)} />
            </div>
          </div>
        ),
      },
    ];
    
  const handleTextCopy = async (text: string) => {
    const res = await copyText(text)
    showSuccess(res.message)
  }
  const defaultColumns = [
    {
      title: t("templateNameLabel"),
      dataIndex: "templateName",
      key: "templateName",

      width: 170,
      ellipsis: true,
    },
    {
      title:selectedChannel===CampaignChannelTypeEnum.ALL
        ?`${t("headerLabel")}/${t("messageLabel")}/${t("previewLabel")}`:selectedChannel === CampaignChannelTypeEnum.SMS
        ? t("messageLabel")
        : selectedChannel === CampaignChannelTypeEnum.WHATSAPP
        ? t("previewLabel")
        : t("headerLabel"),
      dataIndex: "header",
      key: "header",
      width: 200,
      ellipsis: true,
      render: (text: string) => (
        <div className="template-pre-wrap">{text}</div>
      ),
    },
    {
      title: t("campaignAttachedLabel"),
      dataIndex: "campaignAttached",
      key: "campaignAttached",
      width: 80,
      render: (_: any, record: any) => {
        const campaigns = record.campaignAttached || [];
    
        if (!Array.isArray(campaigns) || campaigns.length === 0) {
          return <div className="template-empty-text">—</div>;
        }
    
        return (
          <Link
          to="#"
            className="action-btn mx-1"
            onClick={() => {
              // Format campaign data for table
              setCampaignTableData(
                campaigns.map((c: { id: string; name: string }) => ({
                  key: c.id,
                  name: c.name,
                  id: c.id,
                }))
              );
              setShowDrawer(true); // open drawer
            }}
          >
            {t("viewCampaignsLabel")} {/* or "View Campaigns" */}
          </Link>
        );
      }
    },
    
     ...(selectedChannel === CampaignChannelTypeEnum.WHATSAPP
      ? [
          {
            title: t("categoryLabel"),
            dataIndex: "category",
            key: "category",
            width: 100,
          },
          {
            title: t("statusLabel") ,
            dataIndex: "status",
            key: "status",
            width: 100,

            render: (preview: string) => {
              return (
                <div className="d-flex ">
                  {preview === "Approved" ? (
                    <img
                      src={approvedIcon}
                      alt={"approved"}
                      className="template-container-table-status-img"
                    />
                  ) : preview == "Declined" ? (
                    <img
                      src={declinedIcon}
                      alt={"declined"}
                      className="template-container-table-status-img"
                    />
                  ) : (
                    <img
                      src={reviewIcon}
                      alt={"review"}
                      className="template-container-table-status-img"
                    />
                  )}
                  <span className="template-status-label">{preview}</span>
                </div>
              );
            },
          },
          {
            title: t("languageLabel"),
            dataIndex: "language",
            key: "language",
            width: 100,
          },
        ]
      : []),

    {
      title: t("createdOnLabel"),
      dataIndex: "createdAt",
      key: "createdAt",
      width: 120,
    },
  
    {
        title: t("modifiedOnLabel"),
        dataIndex: "updatedAt",
        key: "updatedAt",
        width: 120,
    },
      

    {
      title: t("actionLabel"),
      dataIndex: "action",
      width: 110,
      className: "text-center",

      render: (action: any) => action,
      key: "action",
    },
  ];
  useEffect(() => {
    dispatch(setCampaignData({}))
    dispatch(setCurrentStep(0));
    dispatch(setSelectedTemplate(null))
  }, [])
  return (
    <div>
      <div className="d-flex justify-content-between flex-wrap my-3">
        <h4 className="fw-semi-bold">{t("messageTemplateLabel")}</h4>
      </div>
      <div className=" template-container">
        <div className="template-body template-container-table p-3 mt-3 ">
          <div className="py-3 m-0 d-flex  justify-content-between w-100">
            <div className="d-flex h-100 gap-2 ">
              <Selector
                placeholder={t("selectChannelLabel")}
                onChange={(value) => setSelectedChannel(value)}
                className="template-channel-selector"
                value={selectedChannel}
                showSearch
                options={channelOptions}
                
              />
              <Search
                placeholder ={t("searchLabel") as string}
                size="middle"
                className=""
                onChange={(e: any) => setSearch(e.target.value)}

              />
               <Selector
                  onChange={(value) => {
                    setPageData({ ...pageData, pageSize: value })
                  }}

                  defaultValue={PAGE_OPTIONS.DEFAULT_VALUE}
                  options={generateNumbersInRange(1, 50).map((num) => ({
                    label: num,
                    value: num,
                  }))}
                  allowManualInput={true}
                  value={pageData.pageSize}
                  />
            </div>
            
          </div>
 
          <CustomTable
            columns={defaultColumns}
            dataSource={tableData}
            onChange={onPageChange}
            pagination={{
              current: pageData.current,
              pageSize: pageData.pageSize,
              simple: pageData.simple,
              total: templates?.total_count,
            }}
            scroll={{ x: selectedChannel == CampaignChannelTypeEnum.WHATSAPP ? 2000 : 2000 }}
            loading={loading}
            size="small"
          />
        </div>
        <SyncModal openModal={modal} setModalOpen={setModal} />
      </div>
      <CustomDrawer
                open={showDrawer}
                placement="right"
                onClose={() => {
                setShowDrawer(BOOLEAN_OPTIONS.FALSE);
                }}
                className="p-0"
                closable={BOOLEAN_OPTIONS.FALSE}
                width={400}
                footer={
                <Space className="d-flex justify-content-end">
                    <PrimaryButton
                    onClick={() => {
                        setShowDrawer(BOOLEAN_OPTIONS.FALSE);
                    }}
                    >
                    {t("cancelLabel")}
                    </PrimaryButton>
                </Space>
                }
                height={"90%"}
             >
                 <CustomTable
    dataSource={campaignTableData}
    columns={campaignTableDataColumns}
    rowKey="key"
    pagination={false}
  />
            </CustomDrawer>
    </div>
  );
};
export default Template;
